import { decode } from '@msgpack/msgpack';
import * as z from 'zod';

import { withLogs } from '@core';

import { apiClient, ApiConfig } from '../apiClient';

type LiveAnalysisArgs = {
    activityId: number;
};

const liveAnalysisEventSchema = z.object({
    parameterId: z.number(),
    tareNum: z.number(),
    value: z.number(),
});

const liveAnalysisEventsSchema = z.array(liveAnalysisEventSchema);

export type LiveAnalysisEvent = z.infer<typeof liveAnalysisEventSchema>;
export type LiveAnalysisEvents = z.infer<typeof liveAnalysisEventsSchema>;

export const getLiveAnalysis = withLogs(
    ({ activityId }: LiveAnalysisArgs) =>
        apiClient
            .get(ApiConfig.path(`/api/v1/activities/${activityId}/live-parameter-values`), {
                responseType: 'arraybuffer',
            })
            .then((res) => {
                const bytes = new Uint8Array(res.data);
                return decode(bytes) as any;
            })
            .then((data) => liveAnalysisEventsSchema.parse(data)),
    'getLiveAnalysis',
);
